export type WorkspaceAgentPanelImageFit = 'clip' | 'crop';

export type WorkspaceAgentPanelImageDimensions = {
  fit: WorkspaceAgentPanelImageFit;
  height: number;
  width: number;
};

/** CSS pixels — pill leading block (`w-[18px]`, `object-cover`). */
export const WORKSPACE_AGENT_PANEL_PILL_THUMBNAIL: WorkspaceAgentPanelImageDimensions = {
  fit: 'crop',
  height: 18,
  width: 18,
};

/** CSS pixels — uncited scope peek stack (`size-5`, `object-cover`). */
export const WORKSPACE_AGENT_PANEL_UNCITED_PEEK_THUMBNAIL: WorkspaceAgentPanelImageDimensions = {
  fit: 'crop',
  height: 20,
  width: 20,
};

/** CSS pixels — asset list row leading block (`size-7`, `object-cover`). */
export const WORKSPACE_AGENT_PANEL_ASSET_LIST_ROW_THUMBNAIL: WorkspaceAgentPanelImageDimensions = {
  fit: 'crop',
  height: 28,
  width: 28,
};

/** CSS pixels — person chip avatar (`size-3.5`, `object-cover`). */
export const WORKSPACE_AGENT_PANEL_PERSON_AVATAR: WorkspaceAgentPanelImageDimensions = {
  fit: 'crop',
  height: 14,
  width: 14,
};

/** CSS pixels — mention row media (`size-8`, `object-cover`). */
export const WORKSPACE_AGENT_PANEL_MENTION_ROW_THUMBNAIL: WorkspaceAgentPanelImageDimensions = {
  fit: 'crop',
  height: 32,
  width: 32,
};

/** CSS pixels — artifact row thumbnail (`size-10`, `object-cover`). */
export const WORKSPACE_AGENT_PANEL_ARTIFACT_THUMBNAIL: WorkspaceAgentPanelImageDimensions = {
  fit: 'crop',
  height: 40,
  width: 40,
};

/** CSS pixels — mention row preview letterbox (`size-[180px]`, `object-contain`). */
export const WORKSPACE_AGENT_PANEL_MENTION_ROW_PREVIEW: WorkspaceAgentPanelImageDimensions = {
  fit: 'clip',
  height: 180,
  width: 180,
};

/** CSS pixels — preview card letterbox cap (`max-w-60` × `max-h-[200px]`, `object-contain`). */
export const WORKSPACE_AGENT_PANEL_PREVIEW_CARD: WorkspaceAgentPanelImageDimensions = {
  fit: 'clip',
  height: 200,
  width: 240,
};

/** CSS pixels — remove-background settings preview (`size-20` well, `object-contain`). */
export const WORKSPACE_AGENT_PANEL_REMOVE_BACKGROUND_PREVIEW: WorkspaceAgentPanelImageDimensions = {
  fit: 'clip',
  height: 80,
  width: 80,
};

/** CSS pixels — rounded-corners settings preview (`size-20` well, `object-cover`). */
export const WORKSPACE_AGENT_PANEL_ROUNDED_CORNERS_PREVIEW: WorkspaceAgentPanelImageDimensions = {
  fit: 'crop',
  height: 80,
  width: 80,
};

/** CSS pixels — thumbnail card (`108px` cell × `h-[73px]`, `object-cover`). */
export const WORKSPACE_AGENT_PANEL_THUMBNAIL_CARD: WorkspaceAgentPanelImageDimensions = {
  fit: 'crop',
  height: 73,
  width: 108,
};

/** CSS pixels — guided grayscale filter preview (`size-[80px]`, `object-cover`). */
export const WORKSPACE_AGENT_PANEL_GRAYSCALE_PREVIEW: WorkspaceAgentPanelImageDimensions = {
  fit: 'crop',
  height: 80,
  width: 80,
};

/** CSS pixels — prompt-card thumbnail (`w-20` × `h-28`, `object-cover`). */
export const WORKSPACE_AGENT_PANEL_PROMPT_CARD_THUMBNAIL: WorkspaceAgentPanelImageDimensions = {
  fit: 'crop',
  height: 112,
  width: 80,
};
